module.exports = __webpack_public_path__ + "static/img/4.788e588.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/7/4.png
// module id = 282
// module chunks = 0